import React from "react";
import { FaPen, FaTrash } from "react-icons/fa";

const BlogTable = ({ blogs, onDelete, onEdit, canWrite = true }) => {
  if (!Array.isArray(blogs)) {
    return <div className="no-variants-message">Loading blogs...</div>;
  }

  if (blogs.length === 0) {
    return (
      <div className="no-variants-message">
        <p>No blogs found</p>
      </div>
    );
  }

  return (
    <div className="luxury-table-container">
      <table className="luxury-table">
        <thead>
          <tr>
            <th>Image</th>
            <th>Title</th>
            <th>URL</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {blogs.map((b) => (
            <tr key={b.id || b._id}>
              <td>
                {b.image ? (
                  <img
                    src={(() => {
                      const img = Array.isArray(b.image) ? b.image[0] : b.image;
                      return typeof img === 'object' && img !== null ? img.url : img;
                    })()}
                    alt={b.title}
                    style={{ width: "50px", height: "50px", objectFit: "cover", borderRadius: "8px" }}
                  />
                ) : (
                  <div className="no-image-placeholder">📝</div>
                )}
              </td>
              <td style={{ fontWeight: "700", color: "#181c32" }}>{b.title}</td>
              <td>{b.blog_url || "-"}</td>
              <td>
                <div className="table-actions">
                  {canWrite && (
                    <>
                      <button className="action-btn edit" onClick={() => onEdit(b)} title="Edit">
                        <FaPen />
                      </button>
                      <button className="action-btn delete" onClick={() => onDelete(b.id || b._id)} title="Delete">
                        <FaTrash />
                      </button>
                    </>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default BlogTable;
